import dynamic from 'next/dynamic';
import { useHasBeenOpened } from '@/components/Modals/hooks/useHasBeenOpened';
import { useUpsellModalState } from '@/features/Downloads/Gateway';

// The upsell body pulls in the whole Subscribe screen stack, which used to
// ride along in `_app` for every visitor (DEV-6485). Split it out and only
// render — and therefore only fetch — once the upsell has actually opened.
const UpsellModalContent = dynamic(() => import('./modal'), {
  ssr: false
});
const UpsellModal = () => {
  const {
    isOpen
  } = useUpsellModalState();
  const hasBeenOpened = useHasBeenOpened(isOpen);
  if (!hasBeenOpened) {
    return null;
  }
  return <UpsellModalContent data-sentry-element="UpsellModalContent" data-sentry-component="UpsellModal" data-sentry-source-file="index.tsx" />;
};
export default UpsellModal;